module.exports = __webpack_public_path__ + "media/ri-hot.c86b9f2f.mp3";